var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVaccines(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.571 11.5235L38.4767 0.429052C37.9047 -0.143017 36.9772 -0.143017 36.4051 0.429052C35.8331 1.00102 35.8331 1.92856 36.4051 2.50063L40.9161 7.01186L36.3308 11.5972L31.8196 7.08608C31.2477 6.51391 30.3201 6.5141 29.7481 7.08608L4.86695 31.9667C4.29488 32.5387 4.29488 33.4661 4.86685 34.0383L9.37829 38.5499L0.429053 47.4994C-0.143018 48.0714 -0.143018 48.9989 0.429053 49.571C0.714991 49.8568 1.08989 50 1.4648 50C1.8397 50 2.2146 49.8569 2.50054 49.5709L11.4499 40.6215L15.9611 45.1329C16.2358 45.4077 16.6085 45.562 16.997 45.562C17.3854 45.562 17.758 45.4077 18.0328 45.1329L42.914 20.252C43.486 19.68 43.486 18.7525 42.914 18.1804L38.4025 13.6689L42.9878 9.08354L47.4995 13.5952C47.7856 13.8813 48.1603 14.0243 48.5352 14.0243C48.9101 14.0243 49.285 13.8812 49.5709 13.5952C50.143 13.0231 50.143 12.0956 49.571 11.5235ZM39.8065 19.2161L35.2215 23.8012L26.1986 14.7786L30.7838 10.1934L39.8065 19.2161Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVaccines);
export default __webpack_public_path__ + "static/media/Vaccines.69e7f83b.svg";
export { ForwardRef as ReactComponent };